/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Review_TitleInputs */

const da_review_title = /** @type {(inputs: Review_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gennemse: Elev ${i?.number}`)
};

/** @type {(inputs: Review_TitleInputs) => LocalizedString} */
const en_review_title = da_review_title;

/**

* @param {Review_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const review_title = /** @type {((inputs: Review_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Review_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_review_title(inputs)
	return da_review_title(inputs)
});